import { useAppSelector } from "../../hooks";
import { helpers } from "../../packages/helpers";
import { AUTH_ENDPOINT_NAMES, authSelectors } from "../auth";
import { CHAT_ENDPOINT_NAMES, chatSelectors } from "../chat";
import { Context } from "./context";
import type { ProviderProps } from "./types";

const {
  // selectModuleErrorMessages: selectAuthModuleErrorMessages,
  selectModuleRequestStatuses: selectAuthModuleRequestStatuses,
} = authSelectors;

const {
  // selectModuleErrorMessages: selectChatModuleErrorMessages,
  selectModuleRequestStatuses: selectChatModuleRequestStatuses,
} = chatSelectors;

const { isNetworkPending, isNetworkError, isNetworkLoading, isNetworkSuccess } =
  helpers.predicates;

export const NetworkProvider = ({ children }: ProviderProps) => {
  const { [AUTH_ENDPOINT_NAMES.AUTH]: authStatus } = useAppSelector(
    selectAuthModuleRequestStatuses
  );

  /*
    const {
      [AUTH_ENDPOINT_NAMES.AUTH]: authError,
    } = useAppSelector(selectAuthModuleErrorMessages);
   */

  const {
    [CHAT_ENDPOINT_NAMES.GET_CHAT_INFO]: getChatInfoStatus,
    [CHAT_ENDPOINT_NAMES.POST_CHAT_INFO]: postChatInfoStatus,
    [CHAT_ENDPOINT_NAMES.GET_MESSAGES]: getMessagesStatus,
    [CHAT_ENDPOINT_NAMES.GET_PREV_MESSAGES]: getPrevMessagesStatus,
    [CHAT_ENDPOINT_NAMES.GET_NEXT_MESSAGES]: getNextMessagesStatus,
    [CHAT_ENDPOINT_NAMES.GET_MESSAGES_BY_REPLY]: getMessagesByReplyStatus,
    [CHAT_ENDPOINT_NAMES.POST_MESSAGE]: postMessageStatus,
  } = useAppSelector(selectChatModuleRequestStatuses);

  /*
    const {
      [CHAT_ENDPOINT_NAMES.GET_CHAT_INFO]: getChatInfoError,
      [CHAT_ENDPOINT_NAMES.GET_MESSAGES]: getMessagesError,
      [CHAT_ENDPOINT_NAMES.GET_PREV_MESSAGES]: getPrevMessagesError,
      [CHAT_ENDPOINT_NAMES.GET_NEXT_MESSAGES]: getNextMessagesError,
      [CHAT_ENDPOINT_NAMES.POST_MESSAGE]: sendMessageError,
    } = useAppSelector(selectChatModuleErrorMessages);
  */

  const isPrevMessagesPending = isNetworkPending(getPrevMessagesStatus);
  const isPrevMessagesLoading = isNetworkLoading(getPrevMessagesStatus);
  const isPrevMessagesSuccess = isNetworkSuccess(getPrevMessagesStatus);

  const isNextMessagesPending = isNetworkPending(getNextMessagesStatus);
  const isNextMessagesLoading = isNetworkLoading(getNextMessagesStatus);
  const isNextMessagesSuccess = isNetworkSuccess(getNextMessagesStatus);

  const isGetMessagesPending = isNetworkPending(getMessagesStatus);
  const isGetMessagesSuccess = isNetworkSuccess(getMessagesStatus);
  const isGetMessagesLoading = isNetworkLoading(getMessagesStatus);
  /* || isGetMessagesPending */

  const isGetMessagesByReplyLoading = isNetworkLoading(
    getMessagesByReplyStatus
  );

  const isGetMessagesByReplySuccess = isNetworkSuccess(
    getMessagesByReplyStatus
  );

  const isPostChatInfoLoading = isNetworkLoading(postChatInfoStatus);
  const isPostChatInfoError = isNetworkError(postChatInfoStatus);

  const isAuthError = isNetworkError(authStatus);
  const isChatConnectError =
    isNetworkError(getMessagesStatus) || isNetworkError(getChatInfoStatus);

  const isMessageSending = isNetworkLoading(postMessageStatus);

  return (
    <Context.Provider
      value={{
        isAuthError,
        isChatConnectError,

        isGetMessagesPending,
        isGetMessagesLoading,
        isGetMessagesSuccess,

        isPrevMessagesPending,
        isPrevMessagesLoading,
        isPrevMessagesSuccess,

        isNextMessagesPending,
        isNextMessagesLoading,
        isNextMessagesSuccess,

        isGetMessagesByReplyLoading,
        isGetMessagesByReplySuccess,

        isPostChatInfoLoading,
        isPostChatInfoError,

        isMessageSending,
      }}
    >
      {children}
    </Context.Provider>
  );
};
